const actions = {
  user: {
    SET_STATE: 'user/SET_STATE',
    GET_CURRENT_ACCOUNT: 'user/GET_CURRENT_ACCOUNT',
    START_PHONE_VERIFICATION: 'user/START_PHONE_VERIFICATION',
    CHECK_PHONE_VERIFICATION: 'user/CHECK_PHONE_VERIFICATION',
    SET_PASSWORD: 'user/SET_PASSWORD',
    REGISTER: 'user/REGISTER',
    LOGIN: 'user/LOGIN',
    LOGOUT: 'user/LOGOUT'
  },
  marketplace: {
    INIT: 'marketplace/INIT',
    SET_STATE: 'marketplace/SET_STATE',
    GET: 'marketplace/GET'
  },
  vendor: {
    INIT: 'vendor/INIT',
    SET_STATE: 'vendor/SET_STATE',
    GET: 'vendor/GET',
    GET_OF_EVENT: 'vendor/GET_OF_EVENT',
    LIST_OF_EVENT: 'vendor/LIST_OF_EVENT'
  },
  product: {
    INIT: 'product/INIT',
    SET_STATE: 'product/SET_STATE',
    GET: 'product/GET',
    LIST: 'product/LIST',
    MORE_LIST: 'product/MORE_LIST'
  },
  vendorProduct: {
    INIT: 'vendorProduct/INIT',
    SET_STATE: 'vendorProduct/SET_STATE',
    GET: 'vendorProduct/GET',
    LIST: 'vendorProduct/LIST',
    MORE_LIST: 'vendorProduct/MORE_LIST'
  },
  category: {
    INIT: 'category/INIT',
    SET_STATE: 'category/SET_STATE',
    GET: 'category/GET',
    LIST_OF_EVENT: 'category/LIST_OF_EVENT'
  },
  cart: {
    INIT: 'cart/INIT',
    SET_STATE: 'cart/SET_STATE',
    ADD: 'cart/ADD',
    UPDATE: 'cart/UPDATE'
  },
  transaction: {
    INIT: 'transaction/INIT',
    SET_STATE: 'transaction/SET_STATE',
    GET: 'transaction/GET',
    GET_MY_LIST: 'transaction/GET_MY_LIST',
    CREATE: 'transaction/CREATE',
    CHARGE: 'transaction/CHARGE',
    CHARGE_CREATE: 'transaction/CHARGE_CREATE'
  },
  notification: {
    INIT: 'notification/INIT',
    SET_STATE: 'notification/SET_STATE'
  }
};

export default actions;
